export function useRedTrack() {
  const URL = '/track';
  const store = useKegelStore();

  async function track(eventName: string): Promise<void> {
    try {
      const viewUrl = `${URL}/postback?clickid=${store.clickId || ''}&sum=0&type=${eventName}`;
      await $fetch(viewUrl);
    } catch (error: unknown) {
      console.error('RED TRACK ERROR', error);
    };
  }

  return {
    track,
  };
}
